<template>
  <DropdownActionItem class="flex items-center" data-test-id="skip" @click="onSkip">
    <SkipAction>
      <template v-slot="{ skip }">
        <Icon name="eye-slashed" class="mr-1" />
        Skip
      </template>
    </SkipAction>
  </DropdownActionItem>
</template>
<script>
import { defineComponent } from 'vue'
import { DropdownActionItem, Icon } from "@sportsrecruits/playbook";
import { mapActions } from "vuex";
import SkipAction from '@/components/AthleteProfile/SkipAction'

export default defineComponent({
  name: "SkipActionItem",
  components: { DropdownActionItem, Icon, SkipAction },
  methods: {
    ...mapActions('athleteProfile', ['skip']),
    async onSkip() {
      await this.skip();
      this.$emit('skipped', this.athlete)
    },
  },
})
</script>